import ProductCatalogServiceFallbackWrapper from '~/services/productCatalog/ProductCatalogServiceFallbackWrapper';
import type ProductCatalogService from '~/services/productCatalog/ProductCatalogService';
import type {RecommenderServiceOptions} from '~/services/productCatalog/types';
import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';

export default class ProductCatalogServiceFactory {
	static async getMyGlobusBonusProgramPriceService(): Promise<ProductCatalogService> {
		const GsoaMyGlobusBonusProgramPriceService = (await import('./impl/GsoaMyGlobusBonusProgramPriceService')).default;
		return new GsoaMyGlobusBonusProgramPriceService();
	}

	static async getKontoBarieryService(): Promise<ProductCatalogService> {
		const GsoaKontoBarieryService = (await import('./impl/GsoaKontoBarieryService')).default;
		return new GsoaKontoBarieryService();
	}

	static async getActionOfferService(): Promise<ProductCatalogService> {
		const GsoaActionOffer = (await import('./impl/GsoaActionOfferService')).default;
		return new GsoaActionOffer();
	}

	static async getFullOfferService(): Promise<ProductCatalogService> {
		const GsoaFullOffer = (await import('./impl/GsoaFullOfferService')).default;
		return new GsoaFullOffer();
	}

	static async getFullOfferFilteredService(): Promise<ProductCatalogService> {
		const GsoaFullOfferFiltered = (await import('./impl/GsoaFullOfferFilteredService')).default;
		return new GsoaFullOfferFiltered();
	}

	static async getRecommendationService(options: RecommenderServiceOptions): Promise<
		| ProductCatalogService<ProductDetail>
		| null
	> {
		const RecommendationService = (await import('./impl/RecommendationService')).default;

		return new ProductCatalogServiceFallbackWrapper({
			service: new RecommendationService(options),
			getFallbackService: options.fallback ?? ProductCatalogServiceFactory.getMyGlobusBonusProgramPriceService,
		});
	}
}
